import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { IconBrandSlack } from '@components/icons/brand-slack';
import { IconBrandWorkplace } from '@components/icons/brand-workplace';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import Add from 'components/icons/add-integration.svg';
import { useStore } from 'models/Provider';

import { IntegrationExample, IntegrationExamples, IntegrationIcon } from './styles';

export const NoIntegrations = observer(() => {
  const { t } = useStore();
  return (
    <Container>
      <Stack space={4} style={{ marginTop: '-10%' }}>
        <IntegrationExamples>
          <IntegrationExample>
            <IconBrandSlack />
          </IntegrationExample>
          <IntegrationExample>
            <IconBrandWorkplace />
          </IntegrationExample>
          <IntegrationExample>
            <IntegrationIcon src={Add} alt="Add integration" />
          </IntegrationExample>
        </IntegrationExamples>
        <div>
          <Text font="heading1">{t('job.integrations.empty.title')}</Text>
          <Text style={{ maxWidth: '35rem' }}>{t('job.integrations.empty.text')}</Text>
        </div>
      </Stack>
    </Container>
  );
});

const Container = styled.div((p) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}));
